import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import services from '../services';
import { tagSchemaObject } from '../TagAmendmentSchema'
import { Fields, validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';

import Chip from '@material-ui/core/Chip';
import EditTag from './EditTag';

import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FactoryGeneral from './FactoryGeneralApprove';

import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";

const screenCode = 'TAGAMENDMENT';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        fontSize: 10,
       
    },
    tabroot:{
        flexGrow: 1
    },
    title: {
        fontSize: 12,
    },
    pos: {
        marginBottom: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    btnrootdel: {
        backgroundColor: '#FF0000',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: " #e60000"
        }

    },
    colorscheme: {
        color: '#10BA57',
    },

    card: {
        alignContent: 'center'
    },

    label: {
        textTransform: 'capitalize',
    },
    rootpaper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    }
}));

function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  };
  


export function TagAmendment(props) {

    const classes = useStyles();
    const schema = Joi.object(tagSchemaObject).options({ allowUnknown: true })

    const [groups, setGroups] = useState();
    const [factoriesData, setFactoriesData] = useState();
    const [collectionPoint, setCollectionPoint] = useState();
    const [searchData, setSearchData] = useState({
        groupID: "",
        operationEntityID: "",
        tag: "",
        date: ""
    });
    const [tagDetails, setTagDetails] = useState({
        routeCode: "",
        date: "",
        cardNo: "",
        supplierRegNo: "",
        grossWeight: "",
        actualAmount:"",
        routeName: "",
        netAmount:"",
        newDate: "",
        customerNo: "",
        deductions: ""
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Success"
    })

    const [chipData, setChipData] = React.useState([

    ]);
    const [TagInfo, setTagInfo] = React.useState({
        newDate: "",
        collectionPointID: ""
    });

  
    const [errors, setErrors] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [value, setValue] = React.useState(0);
    const [tabSectionVisibility, setTabSectionVisibility] = React.useState({
        isFeild:false,
        isFacGeneral:false,
        isFacException:false
    });

    const handleChange = (event, newValue) => {
      setValue(newValue);

      if(value ==0){
          setTabSectionVisibility({
              isFeild:true,
              isFacGeneral:false,
              isFacException:false
          })
      }
    };

    useEffect(() => {
        setGroupDropDownData();
        var datex = (new Date().toISOString()).split("T");
        setSearchData({
            date: datex[0]
        });

    }, []);

    async function setGroupDropDownData() {
        const result = await services.getGroupsForDropdown()
        setGroups(result)
    }

    async function getOperationEntitiesForDropdown(groupID) {
        const opEntities = await services.getAllOperationEntitiesForDropDown(groupID);
        setFactoriesData(opEntities);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clear();
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clear() {
        setTagDetails({
            routeCode: "",
            date: "",
            cardNo: "",
            supplierRegNo: "",
            grossWeight: "",
            routeName: "",
            newDate: "",
            customerNo: "",
            deductions: ""
        });


        setSearchData({
            groupID: "",
            operationEntityID: "",
            tag: "",
            date: ""
        });

        setChipData([]);
    }


    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }


    function handleGroupChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            groupID: target.value
        });
        getOperationEntitiesForDropdown(target.value);
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            operationEntityID: target.value,
        });
    } 

    function handleTagChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            tag: target.value,
        });
    }

    function handleDateChange(target) {
        setTagInfo({
            ...TagInfo,
            newDate: target.value,
        });
    }

    function handleSearchDateChange(target) {
        setSearchData({
            ...searchData,
            date: target.value,
        });
    }

    async function handleSubmit() {
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var response = await services.getTagDetails(searchData);
        if (response != null || response != undefined) {
            setTagInfo(response);
            MaptoTagForm(response);
            setChipData(response.productDeduction);
        }

    }


    function MaptoTagForm(data) {
        var datex = (data.createdDate).split("T");
        setTagDetails({
            ...tagDetails,
            routeCode: data.routeCode,
            date: datex[0],
            cardNo: data.cardNumber,
            supplierRegNo: data.cardNumber,
            grossWeight: data.grossAmount,
            routeName: data.routeName,
            customerNo: data.customerNo,
            actualAmount:data.actualAmount,
            netAmount:data.netAmount,
            productCollectionID:data.productCollectionID
        })
    }


    async function handleUpdate() {
        var response = await services.UpdateTag(TagInfo);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)

    }
    async function handleDeleteTag() {
        var response = await services.RemoveTag(TagInfo);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)

    }
   
    async function handleEdit() {
        setIsEdit(!isEdit);

    }
    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, tagSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

  

    return (
        <Fragment>
            <Paper className={classes.tabroot}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Feild"  {...a11yProps(0)} />
                    <Tab label="Factory General " {...a11yProps(1)} />
                    <Tab label="Factory Exception" {...a11yProps(2)} />

                </Tabs>
                
            </Paper>

            <TabPanel value={value} index={0}>

            <Card className={classes.root}>
                <form className={classes.root} noValidate autoComplete="off">
                    <CardContent>
                        <PageHeader
                            title={"Feild Tag Amendment"}
                            isButtonEnable={false}
                            buttonText="Back to Listing"
                            path="/groups"
                        />
                        <Grid container spacing={3}>

                            <Grid item xs={3} >
                                <TextField
                                    id="groupID"
                                    name="groupID"
                                    select
                                    fullWidth
                                    label="Group *"
                                    value={searchData.groupID}
                                    onChange={(e) => handleGroupChange(e.target)}
                                >
                                    <MenuItem value="0">--Select Group Name--</MenuItem>
                                    {renderDropDown(groups)}
                                </TextField>
                                {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    id="operationEntityID"
                                    name="operationEntityID"
                                    select
                                    fullWidth
                                    label="Factory *"
                                    onChange={(e) => handleOperationEntityChange(e.target)}
                                    value={searchData.operationEntityID}
                                >
                                    <MenuItem value="0">--Select operationEntity Name--</MenuItem>
                                    {renderDropDown(factoriesData)}
                                </TextField>
                                {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    id="tag"
                                    name="tag"
                                    fullWidth
                                    label="TagNumber *"
                                    onChange={(e) => handleTagChange(e.target)}
                                    value={searchData.tag}

                                >
                                </TextField>
                                {errors["tag"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tag"]}</FormHelperText>}
                            </Grid>


                            <Grid item xs={3}>
                                <TextField
                                    id="date *"
                                    fullWidth
                                    type="date"
                                    label="Date"

                                    onChange={(e) => handleSearchDateChange(e.target)}
                                    value={searchData.date}
                                >

                                </TextField>
                            </Grid>



                            <Grid container justify="flex-end">
                                <Button
                                    onClick={() => handleSubmit()}
                                    variant="contained"
                                    className={classes.btnroot}
                                > Search</Button>
                            </Grid>


                        </Grid>
                        <br />
                        <br />


                        <Grid container spacing={3}>
                            <Grid item xs={12} >

                                <Grid container >
                                    <Grid item xs={1} justify="flex-end">
                                        <Switch
                                            color="primary"
                                            label="Edit"
                                            checked={isEdit}
                                            onChange={handleEdit}
                                            name="checkedA"
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                    </Grid>
                                    <Grid item xs={2} justify="flex-start">
                                        <Chip variant="outlined" label={isEdit ? "EditTag" : "View Tag"} color="primary" />
                                    </Grid>
                                </Grid>
                                <Card hidden={isEdit} >
                                    <CardContent>

                                        <br />
                                        <Grid container spacing={3}>
                                            <Grid item xs={6} >

                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Route Code :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="routecode"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.routeCode}
                                                        >

                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Route Name :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.routeName}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Date *:
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField

                                                            id="fromDate"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            type="date"
                                                            disabled={true}
                                                            value={tagDetails.date}

                                                        >

                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Customer No :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.customerNo}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Card No:
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="cardNo"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.cardNo}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>


                                            </Grid>
                                            <Grid item xs={6} >

                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Supplier Reg No :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.supplierRegNo}
                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Gross Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.grossWeight}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={4}>
                                                        <Typography variant="body1" >
                                                            Deductions :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Paper component="ul" className={classes.rootpaper}>
                                                            {chipData.map((data) => {
                                                                let icon;
                                                                return (
                                                                    <li key={data.productDeductionID}>
                                                                        <Chip
                                                                            icon={icon}
                                                                            label={data.deductionTypeName + ":" + data.deductionAmount}
                                                                            className={classes.chip}
                                                                        />
                                                                    </li>
                                                                );
                                                            })}
                                                        </Paper>
                                                    </Grid>
                                                </Grid>


                                            </Grid>



                                        </Grid>
                                    </CardContent>
                                    <CardActions className={classes.card} alignContent={'right'}>
                                        <Grid container justify="flex-end">
                                            <Button
                                                onClick={() => handleDeleteTag()}
                                                variant="contained"
                                                className={classes.btnrootdel}
                                            > Delete</Button>&nbsp;

                                        <Button
                                                onClick={() => clear()}
                                                variant="contained"
                                                className={classes.btnroot}
                                            > Clear</Button>
                                        </Grid>

                                    </CardActions>
                                </Card>
                                <EditTag
                                    activeFilter={searchData}
                                    collectionPointID={TagInfo.collectionPointID}
                                    isEdit={isEdit}
                                    tagDetails={tagDetails}
                                    oldDeductions={chipData}
                                    prevTagInfo={TagInfo}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>

                </form>

                <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
            </Card>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <FactoryGeneral />
            </TabPanel>
            <TabPanel value={value} index={2}>
                Item Three
            </TabPanel>

           
        </Fragment>
    );
}